var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUvIndex01 = function SvgUvIndex01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.33,
    y1: 510.61,
    x2: 497.33,
    y2: 105.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 123.76,
    y1: 586.56,
    x2: 566.76,
    y2: 181.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 131.28,
    y1: 594.78,
    x2: 574.28,
    y2: 189.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -44.02,
    y1: 403.04,
    x2: 398.98,
    y2: -1.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 38.2,
    y1: 492.97,
    x2: 481.2,
    y2: 87.97,
    gradientTransform: "translate(218.98 -270.81) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 164.73,
    y1: 631.37,
    x2: 607.73,
    y2: 226.37,
    gradientTransform: "translate(398.66 -196.36) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 46.69,
    y1: 502.25,
    x2: 489.69,
    y2: 97.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 78.81,
    y1: 537.39,
    x2: 521.81,
    y2: 132.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -34.07,
    y1: 413.92,
    x2: 408.93,
    y2: 8.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -36.65,
    y1: 411.1,
    x2: 406.35,
    y2: 6.1,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M309.33,106.67c-3.86,0-7.69.15-11.48.44l1.63,21.27c3.25-.25,6.53-.37,9.85-.37,70.69,0,128,57.31,128,128s-57.31,128-128,128c-3.31,0-6.59-.12-9.83-.37l-1.64,21.27c3.79.29,7.62.44,11.48.44,82.47,0,149.33-66.86,149.33-149.33s-66.86-149.33-149.33-149.33Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 469.33,
    y: 245.33,
    width: 32,
    height: 21.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 298.67,
    y: 416,
    width: 21.33,
    height: 32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 298.67,
    y: 64,
    width: 21.33,
    height: 32
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 420.05,
    y: 118.26,
    width: 32.68,
    height: 21.33,
    transform: "translate(36.65 346.34) rotate(-45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 425.69,
    y: 366.7,
    width: 21.33,
    height: 32.68,
    transform: "translate(-143.05 420.74) rotate(-45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M352,266.67v-42.67h-21.33v42.67c0,5.89-4.78,10.67-10.67,10.67s-10.67-4.78-10.67-10.67v-42.67h-21.33v42.67c0,17.67,14.33,32,32,32s32-14.33,32-32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362.67,224v21.33c-.02,1.65.35,3.28,1.07,4.77l21.33,42.67c1.82,3.63,5.54,5.92,9.6,5.9,4.06.02,7.78-2.26,9.6-5.9l21.33-42.67c.72-1.49,1.08-3.12,1.07-4.77v-21.33h-21.33v18.82l-10.67,21.33-10.67-21.33v-18.82h-21.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M224,0H53.33C23.89.04.04,23.89,0,53.33v405.33c.04,29.44,23.89,53.3,53.33,53.33h170.67c29.44-.04,53.3-23.89,53.33-53.33V53.33c-.04-29.44-23.89-53.3-53.33-53.33ZM53.33,21.33h170.67c17.67,0,32,14.33,32,32v42.67h-21.33v21.33h21.33v74.67H21.33v-74.67h192v-21.33H21.33v-42.67c0-17.67,14.33-32,32-32ZM224,490.67H53.33c-17.67,0-32-14.33-32-32v-42.67h192v-21.33H21.33v-74.67h21.33v-21.33h-21.33v-85.33h234.67v13.01l-77.26,19.31c-3.82.96-6.8,3.94-7.75,7.75-1.43,5.71,2.04,11.51,7.75,12.94l77.26,19.31v13.01H106.67v21.33h149.33v74.67h-21.33v21.33h21.33v42.67c0,17.67-14.33,32-32,32ZM256,248.33v15.34l-30.69-7.67,30.69-7.67Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64,
    y: 298.67,
    width: 21.33,
    height: 21.33
  })));
};
export default SvgUvIndex01;